'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";

let _ = t => t,
    _t;

import { useSelector } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import UIFlex from 'UIComponents/layout/UIFlex';
import styled, { css } from 'styled-components';
import UISelectableBox from 'UIComponents/button/UISelectableBox';
import UIImage from 'UIComponents/image/UIImage';
import { ProductToIconMap } from '../../constants/ProductToIconMap';
import { activeCurrencySelector } from '../../selectors/CurrencySelectors';
import breakpoint from '../../utils/responsiveBreakpoints';
import PriceDisplay from '../common/pricing/PriceDisplay';
import { GREAT_WHITE } from 'HubStyleTokens/colors';
import Small from 'UIComponents/elements/Small';
const SelectableBox = styled(UISelectableBox).withConfig({
  displayName: "ProductLevelSelectionButton__SelectableBox",
  componentId: "o85mqm-0"
})(["&&&{width:100%;border-radius:0;&:hover{z-index:8;}", ";", ";}"], ({
  disabled
}) => disabled && css(["border-color:", " !important;font-weight:400;"], GREAT_WHITE), ({
  selected
}) => selected && css(["z-index:7;"]));
const StyledProductLevel = styled.span.withConfig({
  displayName: "ProductLevelSelectionButton__StyledProductLevel",
  componentId: "o85mqm-1"
})(["font-weight:500;font-size:14px;"]);
const SelectionButtonWrapper = styled.div.withConfig({
  displayName: "ProductLevelSelectionButton__SelectionButtonWrapper",
  componentId: "o85mqm-2"
})(["width:33.333333%;width:calc(100% / 3);", ";&:not(:first-child){margin-left:-1px;}"], breakpoint.phone(_t || (_t = _`
    display: block;
    width: 100%;
  `)));
const CurrentPlanText = styled.span.withConfig({
  displayName: "ProductLevelSelectionButton__CurrentPlanText",
  componentId: "o85mqm-3"
})(["font-weight:600;"]);
const ButtonContents = styled(UIFlex).withConfig({
  displayName: "ProductLevelSelectionButton__ButtonContents",
  componentId: "o85mqm-4"
})(["height:36px;line-height:18px;margin:4px 0;"]);

const ProductLevelSelectionButton = (_ref) => {
  let {
    selected,
    productLevel,
    disabled,
    onClick,
    isCurrentPlan,
    productLine,
    price
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, ["selected", "productLevel", "disabled", "onClick", "isCurrentPlan", "productLine", "price"]);

  const currencyCode = useSelector(activeCurrencySelector);
  const iconSrc = productLevel && productLine && ProductToIconMap[productLine][productLevel];
  return /*#__PURE__*/_jsx(SelectionButtonWrapper, {
    children: /*#__PURE__*/_jsx(SelectableBox, Object.assign({
      onClick: onClick,
      selected: selected,
      disabled: disabled,
      "data-selenium-class": `${productLevel}-product-level-button`,
      "data-selected": selected,
      "data-disabled": disabled,
      "data-current-plan": isCurrentPlan
    }, rest, {
      children: /*#__PURE__*/_jsxs(ButtonContents, {
        direction: "column",
        align: "center",
        justify: "center",
        children: [/*#__PURE__*/_jsxs(UIFlex, {
          align: "center",
          children: [iconSrc && /*#__PURE__*/_jsx(UIImage, {
            src: iconSrc,
            className: "m-right-1"
          }), /*#__PURE__*/_jsx(StyledProductLevel, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              className: "bold",
              message: `pricingPage.planBuilder.productLevel.${productLevel}`
            })
          })]
        }), /*#__PURE__*/_jsx(Small, {
          children: isCurrentPlan ? /*#__PURE__*/_jsx(CurrentPlanText, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "pricingPage.planBuilder.currentPlanParentheses"
            })
          }) : /*#__PURE__*/_jsx("div", {
            children: /*#__PURE__*/_jsx(FormattedReactMessage, {
              message: "pricingPage.planBuilder.priceDisplay.pricePerMonth",
              options: {
                price: /*#__PURE__*/_jsx(PriceDisplay, {
                  price: price,
                  currencyCode: currencyCode
                })
              }
            })
          })
        })]
      })
    }))
  });
};

export default ProductLevelSelectionButton;